"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InlineFormStore from "Stores/Forms/InlineFormStore";
import { inlineFormShowTable } from "Actions/Forms/InlineFormActions";
import SideDrawerListStore from "Stores/SideDrawerListStore";
import { topBarSetTitle } from "Actions/TopBarActions";
import { formDestroyed } from "Actions/Forms/FormActions";
import { System } from "Constants/objects";
import assert from 'assert';
import { masterDetailReinit } from "Components/TableCore/master_detail";
import { D5Layout } from "Components/Forms/D5Layout";
import { createTableID, getAddSSFilter, getSSTableCols, setAddFilter, setLSTableCols, setShowRowFilter, getShowRowSSFilter } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    formStyle: {
      padding: '8px 8px 8px 16px',
      height: '100%'
    },
    d5FormCaption: {
      fontSize: 20,
      borderBottom: '1px solid #d5d9da',
      paddingBottom: 3,
      margin: '0 2px'
    }
  };
};

var InlineForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InlineForm, _React$Component);

  function InlineForm(props) {
    var _this;

    _classCallCheck(this, InlineForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InlineForm).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.copySSToLS = _this.copySSToLS.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = InlineFormStore.getList();
    return _this;
  }

  _createClass(InlineForm, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(InlineFormStore.getList());
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      InlineFormStore.addChangeListener(this._onChange);
      InlineFormStore.initNewForm({
        formID: this.props.formID
      });

      if (this.props.isActive) {
        var name = SideDrawerListStore.getActiveItemName();
        setTimeout(function () {
          inlineFormShowTable(true);
        });
        topBarSetTitle(name);
      }

      window.addEventListener("beforeunload", this.copySSToLS);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      InlineFormStore.removeChangeListener(this._onChange);
      window.removeEventListener("beforeunload", this.copySSToLS);
      this.copySSToLS();
      InlineFormStore.destructor();
      setTimeout(function () {
        return formDestroyed(_this2.props.UUID);
      });
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextProps.formID !== this.props.formID) {
        this.copySSToLS();
        masterDetailReinit();
        setTimeout(function () {
          inlineFormShowTable(false);
          InlineFormStore.initNewForm({
            formID: nextProps.formID
          });
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var deepStrictEqual = assert.deepStrictEqual;

      try {
        deepStrictEqual(this.props, nextProps);
        deepStrictEqual(this.state, nextState);
      } catch (e) {
        return true;
      }

      return false;
    }
  }, {
    key: "copySSToLS",
    value: function copySSToLS() {
      var items = this.state.items;
      var SUBFORM = System.LAYOUT_TYPE.SUBFORM;

      if (Array.isArray(items)) {
        items.filter(function (item) {
          return item.itemType === SUBFORM;
        }).forEach(function (_ref) {
          var options = _ref.options;

          if (options.formType === System.FORM_TYPE.LIST || options.formType === System.FORM_TYPE.TREE) {
            var lsName = createTableID(options.formID, options.parentFormID);
            setLSTableCols(lsName, getSSTableCols(lsName));
            setAddFilter(lsName, getAddSSFilter(lsName));
            setShowRowFilter(lsName, getShowRowSSFilter(lsName));
            sessionStorage.removeItem(lsName);
            sessionStorage.removeItem("".concat(lsName, "-filter"));
            sessionStorage.removeItem("".concat(lsName, "-row-filter"));
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var _this$state = this.state,
          ready = _this$state.ready,
          groups = _this$state.groups,
          items = _this$state.items;
      return React.createElement(React.Fragment, null, !ready ? null : React.createElement(D5Layout, {
        classes: classes,
        groups: groups,
        items: items
      }));
    }
  }]);

  return InlineForm;
}(React.Component);

_defineProperty(InlineForm, "propTypes", {
  classes: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  UUID: PropTypes.string.isRequired
});

_defineProperty(InlineForm, "defaultProps", {
  isActive: false
});

export default withStyles(styles)(InlineForm);